import { getFinalUrlViaBridge, addPreviewParameter } from '../../util/urlUtils';
import { BridgeClient } from '../../app/service/bridge/BridgeClient';
import { wsClient } from '../../util/appUtils';

async function tryClientSideRedirectDetection(shopAddress, isCompactMode) {
  const prefix = shopAddress.startsWith('http') ? '' : 'https://';
  const fullUrl = `${prefix}${shopAddress}`;

  if (isCompactMode) {
    const bridgeClient = new BridgeClient();
    return getFinalUrlViaBridge(fullUrl, (url) => bridgeClient.getFinalUrl(url));
  }

  return null;
}

async function tryServerSideRedirectDetection(shopAddress) {
  try {
    const prefix = shopAddress.startsWith('http') ? '' : 'https://';
    const fullUrl = `${prefix}${shopAddress}`;

    const response = await wsClient.resolveRedirects(fullUrl, 5000);

    if (response && response.finalUrl) {
      return response.finalUrl;
    }

    return fullUrl;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Backend redirect detection failed:', error.message || error);
    return null;
  }
}

async function safeCall(fn, ...args) {
  try {
    return await fn(...args);
  } catch (error) {
    return null;
  }
}

export async function resolveShopUrl(shopAddress, isCompactMode) {
  if (!shopAddress) {
    return null;
  }

  const prefix = shopAddress.startsWith('http') ? '' : 'https://';
  const fallbackUrl = `${prefix}${shopAddress}`;

  // Embedded/plugin preview must never call the Cloud webservice. Standalone
  // Cloud preview must never instantiate or call the plugin bridge.
  if (isCompactMode) {
    return (await safeCall(tryClientSideRedirectDetection, shopAddress, true)) || fallbackUrl;
  }

  return (await safeCall(tryServerSideRedirectDetection, shopAddress)) || fallbackUrl;
}

export async function buildPreviewUrl(shopAddress, isCompactMode) {
  const finalUrl = await resolveShopUrl(shopAddress, isCompactMode);
  if (!finalUrl) {
    return null;
  }
  return addPreviewParameter(finalUrl, 'kea-preview', 'true');
}
